import { Text } from '@/ui-kit'
import { clsx } from 'clsx'
import { Fragment } from 'react/jsx-runtime'
import { WorkerBase } from '../../api/models'
import { getDeviceDescription } from '../../utils/getDeviceDescription'
import { DevicesListProps } from './DevicesList'

export const DevicesMobileList = <T extends WorkerBase>({
  columns,
  workers,
  selectedWorkerId,
  setSelectedWorkerId
}: DevicesListProps<T>) => {
  return (
    <ul className="mt-4 space-y-2">
      {workers.map((worker) => (
        <li
          key={worker.id}
          className={clsx(
            'relative flex cursor-pointer flex-col gap-1 rounded-2xl border-[1px] border-solid p-4 transition',
            worker.id === selectedWorkerId ? 'borderColor' : 'borderColorGray100to70 hoverBorderColor'
          )}
          onClick={() => setSelectedWorkerId?.(worker.id)}
        >
          <Text className="mb-1">{worker.metadata ? getDeviceDescription(worker.metadata.userAgent) : '-'}</Text>
          {columns.map((column) => (
            <Fragment key={`${worker.id}_${column.name}`}>
              {column.mobileRender?.(worker) ??
                (!column.excludeOnMobile && (
                  <div className="flex">
                    <Text className="text-gray-90 w-[120px]" type="body3-regular">
                      {column.name}
                    </Text>
                    <Text type="body3-regular">{column.value(worker)}</Text>
                  </div>
                ))}
            </Fragment>
          ))}
        </li>
      ))}
    </ul>
  )
}
